import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { ExternalComplianceDrawer } from '~/apps/consumer/components/OrganizationCompliance/ComplianceDrawer/ExternalComplianceDrawer';
import { IngestionFoldersTableCard } from '~/apps/consumer/components/OrganizationCompliance/IngestionFoldersTable';
import { OrganizationComplianceFilters } from '~/apps/consumer/components/OrganizationCompliance/OrganizationComplianceFilters';
import {
  OrganizationCompliancePageProvider,
  useOrganizationCompliancePage,
} from './OrganizationCompliancePageContext';

export const OrganizationCompliancePageContent: FC = () => {
  const {
    folders,
    loading,
    error,
    fetchTriggerRef,
    hasActiveFilters,
    organizationId,
  } = useOrganizationCompliancePage();

  if (!organizationId) {
    return (
      <Box p={6}>
        <Text color="gray.500">No organization selected</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={6}>
        <Text color="red.500">
          Error loading ingestion folders: {error.message}
        </Text>
      </Box>
    );
  }

  return (
    <>
      <Flex direction="column" h="100vh" p={6}>
        <VStack align="stretch" flex="1" minH="0" spacing={4}>
          <Heading size="sm">Organization Compliance</Heading>
          <OrganizationComplianceFilters />
          <IngestionFoldersTableCard
            fetchTriggerRef={fetchTriggerRef}
            folders={folders}
            hasActiveFilters={hasActiveFilters}
            loading={loading}
          />
        </VStack>
      </Flex>

      <ExternalComplianceDrawer />
    </>
  );
};

export const OrganizationCompliancePage: FC = () => {
  return (
    <OrganizationCompliancePageProvider>
      <OrganizationCompliancePageContent />
    </OrganizationCompliancePageProvider>
  );
};
